import reviewCarIcon from "../../../assets/images/review_car_white.svg";

const NomineeFooter = () => (
  <footer className="mt-auto bg-primary py-10 flex justify-center">
    <img src={reviewCarIcon} alt="Review Car" className="w-[170px]" />
  </footer>
);

export default NomineeFooter;
